import { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../Components/Admin/ProtectedRoute';

// Ленивая подгрузка страниц — код модуля не попадает в стартовый бандл.
const AdminLayout = lazy(() => import('../../Components/Admin/AdminLayout'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const UserList = lazy(() => import('./pages/users/UserList'));
const UserEdit = lazy(() => import('./pages/users/UserEdit'));
const WarehouseList = lazy(() => import('./pages/warehouses/WarehouseList'));
const WarehouseNew = lazy(() => import('./pages/warehouses/WarehouseNew'));
const WarehouseEdit = lazy(() => import('./pages/warehouses/WarehouseEdit'));
const DirectionList = lazy(() => import('./pages/directions/DirectionList'));
const DirectionEdit = lazy(() => import('./pages/directions/DirectionEdit'));
const DepartmentList = lazy(() => import('./pages/departments/DepartmentList'));
const JobTitleList = lazy(() => import('./pages/jobTitles/JobTitleList'));
const CounterpartyList = lazy(() => import('./pages/counterparties/CounterpartyList'));
const CounterpartyEdit = lazy(() => import('./pages/counterparties/CounterpartyEdit'));
const ContactPersonList = lazy(() => import('./pages/contactPersons/ContactPersonList'));
const OrganizationList = lazy(() => import('./pages/organizations/OrganizationList'));
const ProductTypeList = lazy(() => import('./pages/productTypes/ProductTypeList'));
const GeneralSettingsPage = lazy(() => import('./pages/generalSettings/GeneralSettingsPage'));
const EmailSettingsPage = lazy(() => import('./pages/emailSettings/EmailSettingsPage'));
const DocPreviewSettingsPage = lazy(() => import('./pages/docPreviewSettings/DocPreviewSettingsPage'));
const BackupPage = lazy(() => import('./pages/backup/BackupPage'));
const StatusCatalogList = lazy(() => import('./pages/statuses/StatusCatalogList'));
const CarrierCatalogList = lazy(() => import('./pages/carriers/CarrierCatalogList'));
const DesktopReleases = lazy(() => import('./pages/desktop/DesktopReleases'));

const AdminRouters = (
  <Route
    path="/admin"
    element={
      <ProtectedRoute minRole="USER">
        <AdminLayout />
      </ProtectedRoute>
    }
  >
    <Route index element={<Dashboard />} />
    <Route
      path="users"
      element={
        <ProtectedRoute minRole="ADMIN">
          <UserList />
        </ProtectedRoute>
      }
    />
    <Route
      path="users/:id"
      element={
        <ProtectedRoute minRole="ADMIN">
          <UserEdit />
        </ProtectedRoute>
      }
    />
    <Route
      path="warehouses"
      element={
        <ProtectedRoute minRole="ADMIN">
          <WarehouseList />
        </ProtectedRoute>
      }
    />
    <Route
      path="warehouses/new"
      element={
        <ProtectedRoute minRole="ADMIN">
          <WarehouseNew />
        </ProtectedRoute>
      }
    />
    <Route
      path="warehouses/:id"
      element={
        <ProtectedRoute minRole="ADMIN">
          <WarehouseEdit />
        </ProtectedRoute>
      }
    />
    <Route
      path="departments"
      element={
        <ProtectedRoute minRole="ADMIN">
          <DepartmentList />
        </ProtectedRoute>
      }
    />
    <Route
      path="job-titles"
      element={
        <ProtectedRoute minRole="ADMIN">
          <JobTitleList />
        </ProtectedRoute>
      }
    />
    <Route
      path="counterparties"
      element={
        <ProtectedRoute minRole="USER">
          <CounterpartyList />
        </ProtectedRoute>
      }
    />
    <Route
      path="counterparties/:id"
      element={
        <ProtectedRoute minRole="USER">
          <CounterpartyEdit />
        </ProtectedRoute>
      }
    />
    <Route
      path="contact-persons"
      element={
        <ProtectedRoute minRole="USER">
          <ContactPersonList />
        </ProtectedRoute>
      }
    />
    <Route
      path="organizations"
      element={
        <ProtectedRoute minRole="ADMIN">
          <OrganizationList />
        </ProtectedRoute>
      }
    />
    <Route
      path="product-types"
      element={
        <ProtectedRoute minRole="ADMIN">
          <ProductTypeList />
        </ProtectedRoute>
      }
    />
    <Route
      path="general-settings"
      element={
        <ProtectedRoute minRole="ADMIN">
          <GeneralSettingsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="email-settings"
      element={
        <ProtectedRoute minRole="ADMIN">
          <EmailSettingsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="doc-preview-settings"
      element={
        <ProtectedRoute minRole="ADMIN">
          <DocPreviewSettingsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="backup"
      element={
        <ProtectedRoute minRole="ADMIN">
          <BackupPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="directions"
      element={
        <ProtectedRoute minRole="ADMIN">
          <DirectionList />
        </ProtectedRoute>
      }
    />
    <Route
      path="directions/:id"
      element={
        <ProtectedRoute minRole="ADMIN">
          <DirectionEdit />
        </ProtectedRoute>
      }
    />
    <Route
      path="statuses"
      element={
        <ProtectedRoute minRole="ADMIN">
          <StatusCatalogList />
        </ProtectedRoute>
      }
    />
    <Route
      path="carriers"
      element={
        <ProtectedRoute minRole="ADMIN">
          <CarrierCatalogList />
        </ProtectedRoute>
      }
    />
    <Route
      path="desktop-releases"
      element={
        <ProtectedRoute minRole="ADMIN">
          <DesktopReleases />
        </ProtectedRoute>
      }
    />
  </Route>
);

export default AdminRouters;
